<template>
    <v-app>
        <main-view/>
    </v-app>
</template>

<script>

import Main from './components/Main';

export default {
    name: 'App',
    components: {
        'main-view': Main,
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
}
</script>

<style>
html {
    overflow-y: scroll;
}

body {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #3d3d3d;
}

.link {
    text-decoration: none;
    color: #eb5c2e !important;
    font-weight: bold;
    padding: 0 0.5em;
    transition: all 0.15s ease-in;
}

.link:hover {
    color: white !important;
    background-color: #eb5c2e;
}

table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
}

tr {
    height: 3em;
}

.bottom_white_border {
    border-bottom: 1px solid #eba484;
}

.orange_cell {
    background-color: #eb5c2e;
    color: white;
}

h1 {
    font-weight: lighter;
    text-align: center;
}

h2 {
    font-weight: normal;
    font-size: 1.3em;
    color: #585858;
}

.title_display {
    cursor: pointer;
    user-select: none;
}

.multiselect__spinner:after, .multiselect__spinner:before {
    border-color: #eb5c2e transparent transparent !important;
}

.multiselect__option--highlight {
    background-color: #eb5c2e !important;
}

.fade-enter-active {
    transition: opacity 0.25s ease-in 0.25s, min-height 0.25s ease-in;
}

.fade-leave-active {
    transition: opacity 0.25s ease-in, min-height 0.25s ease-in 0.25s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
    min-height: 0;
}

.v-text-field {
    padding-top: 12px;
    width: 5em;
    margin: 4px auto auto;
    font-size: 14px;
}

.v-text-field__slot > input {
    text-align: right;
}

.ref-code {
    font-style: italic;
    font-size: 0.8em;
    color: #515151;
}

/* Classes provenant de l'éditeur Quill dans le front d'Archibald */

.ql-size-small {
    font-size: 0.75em;
}

.ql-size-large {
    font-size: 1.5em;
}

.ql-size-huge {
    font-size: 2.5em;
}

.ql-align-center {
    text-align: center;
}

.ql-align-right {
    text-align: right;
}

.ql-align-justify {
    text-align: justify;
}

.ql-font-serif {
    font-family: serif;
}

.ql-font-monospace {
    font-family: monospace;
}

.ql-indent-1 {
    padding-left: 3em;
}

.ql-indent-2 {
    padding-left: 6em;
}

.ql-indent-3 {
    padding-left: 9em;
}

.ql-indent-4 {
    padding-left: 12em;
}

.ql-indent-5 {
    padding-left: 15em;
}

.ql-indent-6 {
    padding-left: 18em;
}

.ql-indent-7 {
    padding-left: 21em;
}

.ql-indent-8 {
    padding-left: 24em;
}

.tarif-unused {
    background-color: #f3f3f3;
    color: #c1c1c1;
}

</style>



// WEBPACK FOOTER //
// src/App.vue